var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row pb-5" }, [
      _c("div", { staticClass: "col-12 col-lg-8" }, [
        _c("div", { staticClass: "pb-4" }, [_c("top-stories-panel")], 1),
        _vm._v(" "),
        _c("div", { staticClass: "pb-4" }, [_c("news-by-interests")], 1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pb-4" },
          [_c("resources-panel", { ref: "resourcesPanel" })],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-4 pl-lg-2" }, [
        _c("div", { staticClass: "pb-4" }, [_c("right-panel")], 1)
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9356c24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9356c24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/HomebaseHome.vue
// module id = null
// module chunks = 